var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._m(0),_vm._m(1),_c('div',{staticClass:"footer"},[_c('div',{ref:"charts",staticClass:"charts"})])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"header"},[_c('span',{staticClass:"saerch-header",staticStyle:{"color":"#8a8a8a"}},[_vm._v("会员分布")])])
},function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main"},[_c('span',{staticClass:"main-title"},[_vm._v("2.7")])])
}]

export { render, staticRenderFns }